import {React, useEffect, useState} from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Avatar from "./Avatar";
import axios from "axios";
import "./Admin.css"; 

const StudentDashboard = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const username = sessionStorage.getItem("username");
    if (!username) {
      navigate("/Signin"); // redirect if not logged in
    }
  }, [navigate]);
  const userName = sessionStorage.getItem("username"); // Replace with dynamic data if needed
  const userID = sessionStorage.getItem("userId");
  const userImage = "https://broken-link.com/avatar.png"; // Replace with real or test URL
  const [todaysClasses, setTodaysClasses] = useState([]);
  const [notifiedClasses, setNotifiedClasses] = useState([]);
  const [istClock, setIstClock] = useState("");

   // Format date header in IST
   const formatISTDate = () =>
    new Date().toLocaleDateString("en-IN", {
      timeZone: "Asia/Kolkata",
      weekday: "long",
      day: "numeric",
      month: "short",
      year: "numeric",
    });

  // Class status based on DB times
  // Convert "HH:MM" string to Date object in IST
  const getISTDateTime = (timeStr) => {
  const [hours, minutes] = timeStr.split(":").map(Number);
  const now = new Date();
  
  // Get current date in IST
  const istDate = new Date(
    now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
  );

  // Set the hours/minutes of the class
  istDate.setHours(hours, minutes, 0, 0);
  return istDate;
};

// Determine class status based on IST
const getClassStatus = (start, end) => {
  const nowIST = new Date(
    new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
  );
  const startTime = getISTDateTime(start);
  const endTime = getISTDateTime(end);

  if (nowIST < startTime) return "upcoming";
  if (nowIST >= startTime && nowIST <= endTime) return "ongoing";
  return "past";
};

// Countdown timer in IST
const getCountdown = (start) => {
  const nowIST = new Date(
    new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
  );
  const startTime = getISTDateTime(start);

  if (nowIST >= startTime) return "Started";

  let diff = (startTime - nowIST) / 1000; // seconds
  const hours = Math.floor(diff / 3600);
  diff %= 3600;
  const minutes = Math.floor(diff / 60);
  //const seconds = Math.floor(diff % 60);

  if (hours === 0) {
    return `Starts in ${minutes}m`;
  } else {
    return `Starts in ${hours}h ${minutes}m`;
  }
};

  // Sound & alert when class starts
  const checkClassStart = (start, id) => {
    const now = new Date();
    const [h, m] = start.split(":");
    const startTime = new Date();
    startTime.setHours(h, m, 0);

    if (now >= startTime && !notifiedClasses.includes(id)) {
      setNotifiedClasses((prev) => [...prev, id]);
    }
  };

  const isOngoing = (start, end) => getClassStatus(start, end) === "ongoing";

  // Table times (DB values) no conversion
 // Convert "HH:MM" to "hh:mm AM/PM"
  const formatTime = (timeStr) => {
  if (!timeStr) return "";
  const [hourStr, minuteStr] = timeStr.split(":");
  let hour = parseInt(hourStr, 10);
  const minute = parseInt(minuteStr, 10);
  const ampm = hour >= 12 ? "PM" : "AM";
  hour = hour % 12 || 12; // convert 0 -> 12, 13 -> 1, etc.
  return `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")} ${ampm}`;
};

  // Fetch data & update IST clock
  useEffect(() => {
    if (!userID) return; // Avoid running until userID exists
  
    // Fetch today's classes
    const fetchTodaysClasses = async () => {
      try {
        //const response = await axios.get(`http://localhost:8000/api/Student_today-classes/${userID}`);
        const response = await axios.get(`https://alphabeta4success.com/api/Student_today-classes/${userID}`);
        setTodaysClasses(response.data?.data || response.data);
      } catch (err) {
        console.error("Error fetching today's classes:", err);
      }
    };
  
    fetchTodaysClasses();
  
    // Refresh classes every 1 minute
    const classesInterval = setInterval(fetchTodaysClasses, 60000);
  
    // IST clock update
    const clockInterval = setInterval(() => {
      const ist = new Date().toLocaleTimeString("en-IN", {
        hour12: true,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZone: "Asia/Kolkata",
      });
      setIstClock(ist);
    }, 1000);
  
    return () => {
      clearInterval(classesInterval);
      clearInterval(clockInterval);
    };
  }, [userID]); 

  useEffect(() => {
    // Highlight active sidebar item
    const allSideMenu = document.querySelectorAll('#sidebar .side-menu.top li a');
  
    allSideMenu.forEach(item => {
      const li = item.parentElement;
  
      item.addEventListener('click', () => {
        allSideMenu.forEach(i => {
          i.parentElement.classList.remove('active');
        });
        li.classList.add('active');
      });
    });
  
    // Toggle sidebar
    const menuBar = document.querySelector('#sidebar-toggle');
    const sidebar = document.getElementById('sidebar');
  
    const toggleSidebar = () => {
      sidebar?.classList.toggle('hide');
    };
  
    menuBar?.addEventListener('click', toggleSidebar);
  
    // Search toggle
    const searchButton = document.querySelector('#content nav form .form-input button');
    const searchButtonIcon = document.querySelector('#content nav form .form-input button svg');
    const searchForm = document.querySelector('#content nav form');
  
    const handleSearchClick = (e) => {
      if (window.innerWidth < 576) {
        e.preventDefault();
        searchForm?.classList.toggle('show');
      }
    };
  
    searchButton?.addEventListener('click', handleSearchClick);
  
    // Responsive behavior
    const handleResize = () => {
      if (window.innerWidth > 576) {
        searchForm?.classList.remove('show');
      }
    };
  
    window.addEventListener('resize', handleResize);
  
    // Dark mode
    const switchMode = document.getElementById('switch-mode');
    const toggleMode = () => {
      if (switchMode?.checked) {
        document.body.classList.add('dark');
      } else {
        document.body.classList.remove('dark');
      }
    };
  
    switchMode?.addEventListener('change', toggleMode);
  
    // Initial responsive setup
    if (window.innerWidth < 768) {
      sidebar?.classList.add('hide');
    } else if (window.innerWidth > 576) {
      searchForm?.classList.remove('show');
    }
  
    // Cleanup listeners
    return () => {
      menuBar?.removeEventListener('click', toggleSidebar);
      searchButton?.removeEventListener('click', handleSearchClick);
      window.removeEventListener('resize', handleResize);
      switchMode?.removeEventListener('change', toggleMode);
    };
  }, []);
  
  return (
    <div>
      {/* Sidebar */}
      <section id="sidebar">
        <Link to="#" className="brand">
        <img
          src="/Assets/images/AB4S_logo.png"
          alt="AB4S"
          className="sidebar-logo"
        />
        </Link>
        <ul className="side-menu top">
          <li className="active"><Link to="/StudentDashboard"><i className="bx bxs-dashboard"></i><span className="text">Dashboard</span></Link></li>
          <li><Link to="#"><i className="bx bx-file"></i><span className="text">File Manager</span></Link></li>
          <li><Link to="/Password"><i className="bx bx-message-edit"></i><span className="text">Reset Password</span></Link></li>
          <li><Link to="#"><i className="bx bx-calendar-event"></i><span className="text">Calender</span></Link></li>  
        </ul>
        <ul className="side-menu">
          <li><Link to="#"><i className="bx bxs-cog"></i><span className="text">Settings</span></Link></li>
          <li><Link to="/Signin" className="logout"><i className="bx bx-log-out"></i><span className="text">Logout</span></Link></li>
        </ul>
      </section>

      {/* Content */}
      <section id="content">
        <nav>
          <i className="bx bx-menu"></i>
          <h3><span className="highlight-purple">Happy Learning <i className='bx bxs-smile'></i></span></h3>
          <form>
            <div className="form-input">
              <input type="search" placeholder="Search..." />
              <button type="submit" className="search-btn">
                <i className="bx bx-search"></i>
              </button>
            </div>
          </form>
          <input type="checkbox" id="switch-mode" hidden />
          <label htmlFor="switch-mode" className="switch-mode"></label>
          <div className="topbar-right" style={{ display: "flex", alignItems: "center", gap: 30 }}>
            <span style={{ marginRight: "6px", fontWeight: 600 }}>
              ⏰ -  {istClock} : IST
            </span>
            <span style={{ marginLeft: 8 }}><h3>Welcome, {userName}</h3></span>
            <Avatar name={userName} src={userImage} size={30} className="avatar" />
          </div>
        </nav>

        <main>
          <div className="head-title">
            <div className="left">
              <h2>Dashboard</h2>
              <ul className="breadcrumb">
                <li><Link to="#">Student</Link></li>
                <li><i className="bx bx-chevron-right"></i></li>
                <li><Link to="#" className="active">Home</Link></li>
              </ul>
            </div>
          </div>
          <div className="table-data">
            <div className="order">
              <div className="head">
                <h3>Today's class — {formatISTDate()}</h3>
                <i className="bx bx-search"></i>
                <i className="bx bx-filter"></i>
              </div>
              <table>
                <thead>
                  <tr>
                    <th>Class Time : (IST)</th>
                    <th>Subject</th>
                    <th>Tutor</th>
                    <th>Class Mode</th>
                    <th>Class Status</th>
                    <th>Class Link</th>
                  </tr>
                </thead>
                <tbody>
                  {todaysClasses.length === 0 ? (
                    <tr><td colSpan="6" style={{ textAlign: "center" }}>No classes scheduled today.</td></tr>
                  ) : (
                    todaysClasses.map((cls) => {
                      const status = getClassStatus(cls.Start_time, cls.End_time);
                      const ongoing = isOngoing(cls.Start_time, cls.End_time);

                      // Sound & popup alert
                      checkClassStart(cls.Start_time, cls.ID);
                      return (
                        <tr key={cls.ID} className={ongoing ? "ongoing-class" : ""}>
                          <td>
                            {formatTime(cls.Start_time)} - {formatTime(cls.End_time)}
                            <div style={{ fontSize: "12px", color: "#666" }}>
                              {status === "upcoming" && getCountdown(cls.Start_time)}
                            </div>
                          </td>
                          <td>{cls.Subject}</td>
                          <td>{cls.Tutor}</td>
                          <td>{status}</td>
                          <td>{cls.Meetingstatus}</td>
                          <td className="class-link-cell">
                            {status === "past" ? (
                              <span className="disabled-link">Completed</span>
                            ) : (
                              <a
                                href={`https://alphabeta4success.com/vindex.html?meetingID=${cls.Meeting_ID}&classID=${cls.ID}&UR=${"S"}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={status === "upcoming" ? "upcoming-link" : "ongoing-link"}
                              >
                                Join
                              </a>
                            )}
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </main>
      </section>
    </div>
  );
};

export default StudentDashboard;
